var map = {
	"./administrador.png": "db97",
	"./bodega.png": "4f6d",
	"./compras.png": "af8c",
	"./contabilidad.png": "2eb5",
	"./contactos-web.png": "14dc",
	"./contactos.png": "370c",
	"./controlados.png": "f25a",
	"./crm-1.png": "625c",
	"./crm-2.jpg": "aa10",
	"./crm-3.png": "c925",
	"./crm-4.png": "b92a",
	"./crm-5.jpg": "dce5",
	"./delivery-icon-12 (2).png": "a2a1",
	"./delivery.png": "1241",
	"./direcciones.jpg": "18cc",
	"./direcciones.png": "1683",
	"./ecommerce.png": "7691",
	"./grupo-inno.jpg": "1670",
	"./laboratorio.jpg": "0c6c",
	"./laboratorio.png": "2b4d",
	"./logo-img.jpeg": "8c7f",
	"./nomina.png": "8b39",
	"./personal.jpg": "84f3",
	"./placetopay-logo.png": "699d",
	"./placetopay.png": "96d6",
	"./pos.png": "1f92",
	"./productos-ecommerce.jpg": "3d7b",
	"./psicotropicos.png": "ddec",
	"./redes.png": "9dd8",
	"./referencia-personal.png": "b826",
	"./sedes.png": "516d",
	"./slider-ecommerce.jpg": "8809",
	"./slider-principal.png": "cd0c",
	"./usuarios.png": "d008",
	"./warehouse-1073.svg": "21da",
	"./web.png": "6436",
	"./whastapp.png": "479c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";